
import { Component, Vue, Prop } from 'vue-property-decorator';

interface Link {
  label: string
  href: string
}

enum Font {
  POPPINS = 'poppins',
  PT_MONO = 'mono',
}

@Component
export default class SiteMap extends Vue {
  @Prop({ default: false }) isDark!: boolean;
  @Prop({ required: true }) links!: Link[];
  @Prop({ default: Font.PT_MONO }) font!: Font;

  get classNames() {
    return [
      { 'site-map--dark': this.isDark },
    ];
  }


  get style() {
    return {
      fontFamily: this.font === Font.POPPINS ? '"Poppins", sans-serif' : '"PT Mono", monospace',
      // fontSize: this.font === Font.POPPINS ? '16px' : '18px', // poppins needs smaller
    };
  }
}
